import NavigationBar from "./NavigationBar";
import NewUserModal from "../NewUserModal";
import NewUserModalBackdrop from "../NewUserModalBackdrop";
import logoX from "../../images/X_logo.png";
import logoFacebook from "../../images/Facebook_logo.png";
import logoInstagram from "../../images/Instagram_logo.png";

import classes from "./Layout.module.css";

function Layout(props) {
  return (
    <div className={classes.layout_containerDiv}>
      <NavigationBar />
      <main>
        <div className={classes.layout_mainContainer}>
          <div className={classes.layout_headingDiv}>
            <div className={classes.layout_followDiv}>
              <div className={classes.layout_followIconDiv}>
                <a
                  href="https://twitter.com/PolldockDotCom"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={classes.layout_followIconImg}
                    src={logoX}
                    alt="X"
                  />
                </a>
              </div>
              <div className={classes.layout_followIconDiv}>
                <a
                  href="https://www.instagram.com/polldockdotcom/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={classes.layout_followIconImg}
                    src={logoInstagram}
                    alt="Instagram"
                    rel="noopener noreferrer"
                  />
                </a>
              </div>
              <div className={classes.layout_followIconDiv}>
                <a
                  href="https://www.facebook.com/profile.php?id=61553596394215"
                  target="_blank"
                >
                  <img
                    className={classes.layout_followIconImg}
                    src={logoFacebook}
                    alt="Facebook"
                  />
                </a>
              </div>

            </div>
          </div>
          {props.children}
        </div>
      </main>
      {props.showNewUserModal ? <NewUserModalBackdrop setShowNewUserModal={props.setShowNewUserModal} /> : null}
      {props.showNewUserModal ? <NewUserModal setShowNewUserModal={props.setShowNewUserModal} /> : null}
    </div>
  );
}

export default Layout;
